import type { GetStaticProps } from 'next';

import type { ABVariant } from '@/constants/abTest';
import PromoAPage from '@/domains/marketing/pages/promoA/PromoA';

type PromoVariantPageProps = {
  abVariant: ABVariant;
};

export default function PromoVariantAPage() {
  return <PromoAPage />;
}

export const getStaticProps: GetStaticProps<
  PromoVariantPageProps
> = async () => {
  return { props: { abVariant: 'v-a' } };
};
